import React, { Component } from 'react';
import { ApolloProvider } from 'react-apollo';
import { Button, Icon, Divider, Modal } from 'semantic-ui-react';
import MediasContainer from '../containers/MediasContainer';
import { inlineStyle } from '../styles/custom';
import { client } from '../apollo/ApolloClient';

class MediaButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: {
        open: false,
        insertUnavailable: true,
      },
      media: null,
    };
  }

  // Handle click a media
  handleClick = (event, media) => {
    this.setState({
      media: media,
      modal: {
        ...this.state.modal,
        insertUnavailable: false,
      },
    });
  };

  // Click on insert button
  onClick = (e) => {
    if (this.state.media) {
      this.props.handleClick(
        e,
        this.state.media,
        this.props.language,
        this.props.id,
        this.props.type,
      );
      this.setState({
        media: null,
        modal: {
          open: false,
          insertUnavailable: true,
        },
      });
    }
  };

  // Show modal
  onShow = () => {
    this.setState({
      modal: {
        ...this.state.modal,
        open: true,
      },
    });
  };

  // Close modal
  onClose = () => {
    this.setState({
      media: null,
      modal: {
        open: false,
        insertUnavailable: true,
      },
    });
  };

  render() {
    let styles = {
      wrapper: {
        display: 'inline-block',
        verticalAlign: 'middle',
        width: 'auto',
      },
    };

    if (this.props.fluid) {
      styles.wrapper.width = '100%';
    }

    return (
      <div style={styles.wrapper}>
        <Button onClick={this.onShow} fluid={this.props.fluid || false}>
          <Icon name={this.props.icon || 'file'} />{' '}
          {this.props.label || 'Insérer'}
        </Button>

        <Modal open={this.state.modal.open} style={inlineStyle.modal}>
          <ApolloProvider client={client}>
            <Modal.Header>Selectionnez un média</Modal.Header>
            <Modal.Content scrolling>
              <MediasContainer handleClick={this.handleClick} />
            </Modal.Content>
            <Modal.Actions>
              <Button floated="left" onClick={this.onClose}>
                Annuler
              </Button>
              <Button
                floated="right"
                onClick={this.onClick}
                disabled={this.state.modal.insertUnavailable}
                primary
              >
                Insérer
              </Button>
              <Divider clearing hidden fitted />
            </Modal.Actions>
          </ApolloProvider>
        </Modal>
      </div>
    );
  }
}

export default MediaButton;



// WEBPACK FOOTER //
// ./src/components/MediaButton.js